<template functional>
  <div>
    <p class="mb-3">
      ВНИМАНИЕ!
    </p>

    <p class="mb-3">
      ЭТО ЧАСТНАЯ КОМПЬЮТЕРНАЯ СИСТЕМА, ПРИНАДЛЕЖАЩАЯ ГРУППЕ КОМПАНИЙ «СОЛЛЕРС». ЕЁ ИСПОЛЬЗОВАНИЕ ОТСЛЕЖИВАЕТСЯ. НЕПРАВОМЕРНЫЙ ДОСТУП ИЛИ ИСПОЛЬЗОВАНИЕ МОГУТ ПОВЛЕЧЬ УГОЛОВНУЮ ОТВЕТСТВЕННОСТЬ, ПРИМЕНЕНИЕ ДИСЦИПЛИНАРНЫХ МЕР ВПЛОТЬ ДО УВОЛЬНЕНИЯ, РАСТОРЖЕНИЯ ДОГОВОРА ИЛИ ЗАПРЕТА ДОСТУПА К СИСТЕМЕ.
    </p>

    <p class="mb-3">
      Система может содержать конфиденциальные данные группы компаний «СОЛЛЕРС», аффилированных с ней компаний, дилеров и поставщиков. Эти данные не подлежат разглашению без надлежащего разрешения со стороны группы компаний «СОЛЛЕРС». Вы отвечаете за безопасность и конфиденциальность информации, к которой получаете доступ, а также подтверждаете, что будете использовать её только для целей, согласованных с группой компаний «СОЛЛЕРС».
      Группа компаний «СОЛЛЕРС» обладает всеми правами на необнародованные произведения, созданные группой компаний «СОЛЛЕРС» и созданные для неё, а также сохраняет за собой право защищать авторские права как на обнародованные, так и на необнародованные произведения.
    </p>

    <p class="mb-3">
      Продолжая использовать эту Систему, вы соглашаетесь с этими условиями использования.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppAgreement',
  functional: true,
};
</script>
